export default __webpack_public_path__ + "static/media/bg-gray.e85265e4.png";